import { PageModuleData } from "entities/pages/types";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "shared/api/firebase";

export const getModulesListByBrandSetting = async (
  brandId: string,
  settingId: string,
): Promise<PageModuleData[]> => {
  try {
    const collectionRef = collection(
      db,
      `brands/${brandId}/settings/${settingId}/modules`,
    );
    const q = query(collectionRef, orderBy("order", "asc"));

    const settingsSnapshot = await getDocs(q);

    return settingsSnapshot.docs.map(
      (doc) => ({ ...doc.data(), id: doc.id }) as PageModuleData,
    );
  } catch (error) {
    console.error("Failed to fetch modules list:", error);
    throw error;
  }
};
